import { ReactNode, useMemo } from 'react';
import PageTopSection from '@/creditflowresearch/ui/common/components/templates/PageTopSection';
import TogglingFiltersFallback from '@/creditflowresearch/ui/common/components/organisms/TogglingFiltersFallback';
import Breadcrumbs from '@creditflowresearch/uilib/Breadcrumbs';
import { useBreadcrumbsContext } from '@/creditflowresearch/ui/common/components/header/Breadcrumbs';
import { type IFilterButtonSet } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

interface IProductPageHeaderContentProps {
  title: ReactNode,
  items: ReactNode | IFilterButtonSet[],
  hasBlockingAccessFailure: boolean,
}

const ProductPageHeaderContent = ({
  title,
  items,
  hasBlockingAccessFailure,
}: IProductPageHeaderContentProps) => {
  const { breadcrumbs } = useBreadcrumbsContext();

  const blockingAccessFallback = useMemo(
    () => (
      <PageTopSection
        title={ title }
        items={ <TogglingFiltersFallback /> }
      >
        <Breadcrumbs breadcrumbs={ breadcrumbs } />
      </PageTopSection>
    ),
    [title, breadcrumbs],
  );

  const pageTopSection = (
    <PageTopSection
      title={ title }
      items={ items }
    >
      <Breadcrumbs breadcrumbs={ breadcrumbs } />
    </PageTopSection>
  );

  return hasBlockingAccessFailure ? blockingAccessFallback : pageTopSection;
};

export default ProductPageHeaderContent;
